export default __webpack_public_path__ + "static/media/The Circle's Notch.b5c32e31.jpg";